const defaultState = {};

const items = (() => {
  let res = {};
  Object.keys(defaultState).forEach((category) => {
    res = { ...res, ...defaultState[category] };
  });
  Object.keys(res).forEach((key) => {
    res[key].real_label = key;
  });
  return res;
})();

export default (state = items, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export const classesSelector = (state) => state.classes;
